<template>
 <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.75 -0.75 24 24"
    height="24"
    width="24"
  >
    <defs></defs>
    <title>pathfinder-intersect</title>
    <path
      d="M7.265625 6.328125h8.90625l0 0v8.90625a0.9375 0.9375 0 0 1 -0.9375 0.9375h-8.90625l0 0v-8.90625a0.9375 0.9375 0 0 1 0.9375 -0.9375Z"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M0.703125 2.109375a1.40625 1.40625 0 0 1 1.40625 -1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m4.921875 0.703125 2.109375 0"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m9.84375 0.703125 2.109375 0"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M14.765625 0.703125a1.40625 1.40625 0 0 1 1.40625 1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m16.171875 6.328125 0 -1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m0.703125 4.921875 0 2.109375"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m0.703125 9.84375 0 2.109375"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M0.703125 14.765625a1.40625 1.40625 0 0 0 1.40625 1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m6.328125 16.171875 -1.40625 0"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M20.390625 21.796875a1.40625 1.40625 0 0 0 1.40625 -1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m21.796875 17.578125 0 -2.109375"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m21.796875 12.65625 0 -2.109375"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M21.796875 7.734375a1.40625 1.40625 0 0 0 -1.40625 -1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m16.171875 6.328125 1.40625 0"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m17.578125 21.796875 -2.109375 0"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m12.65625 21.796875 -2.109375 0"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M7.734375 21.796875a1.40625 1.40625 0 0 1 -1.40625 -1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m6.328125 16.171875 0 1.40625"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
  </svg>

</template>

<script>
export default {};
</script>

<style>
</style>